// Woocommmerce

( function( $ ) {

    /**
     * Parse a localized WooCommerce price string into a float.
     * Strips currency symbols and common thousands/decimal separators.
     *
     * @param {string} text
     * @returns {number}
     */
    function juncParsePrice( text ) {
        if ( ! text ) {
            return NaN;
        }

        // Remove HTML, trim, and strip everything except digits, separators, minus sign.
        var raw = $('<div>').html( text ).text().trim();

        // Replace non-numeric (excluding , . -) with space, then collapse spaces.
        raw = raw.replace( /[^0-9,.\-]/g, ' ' ).replace( /\s+/g, ' ' ).trim();

        if ( ! raw ) {
            return NaN;
        }

        // Take last numeric-ish token, prices are usually at the end.
        var parts = raw.split( ' ' );
        var candidate = parts[ parts.length - 1 ];

        // If both , and . are present, assume the last one is the decimal separator.
        var hasComma = candidate.indexOf( ',' ) !== -1;
        var hasDot   = candidate.indexOf( '.' ) !== -1;

        if ( hasComma && hasDot ) {
            if ( candidate.lastIndexOf( ',' ) > candidate.lastIndexOf( '.' ) ) {
                // Comma as decimal: remove dots as thousands, replace comma with dot.
                candidate = candidate.replace( /\./g, '' ).replace( /,/g, '.' );
            } else {
                // Dot as decimal: remove commas as thousands.
                candidate = candidate.replace( /,/g, '' );
            }
        } else if ( hasComma && ! hasDot ) {
            // Only comma: treat as decimal separator.
            candidate = candidate.replace( /,/g, '.' );
        } else {
            // Only dot or none: just remove thousands separators if clearly grouping.
            // Simple heuristic: if more than 3 digits before a separator, strip separators.
            candidate = candidate.replace( /,/g, '' );
        }

        return parseFloat( candidate );
    }

    /**
     * Hide zero-value subtotal/total rows on the cart page.
     */
    function juncHideZeroCartTotals() {
        if ( ! $( 'body' ).hasClass( 'woocommerce-cart' ) ) {
            return;
        }

        var $table = $( '.cart_totals table.shop_table' );
        if ( ! $table.length ) {
            return;
        }

        [ '.cart-subtotal', '.order-total' ].forEach( function( selector ) {
            var $row = $table.find( selector );
            if ( ! $row.length ) {
                return;
            }

            var $cell = $row.find( 'td' ).first();
            if ( ! $cell.length ) {
                return;
            }

            var value = juncParsePrice( $cell.html() );

            if ( ! isNaN( value ) && value === 0 ) {
                $row.css( 'display', 'none' );
            } else {
                $row.css( 'display', '' );
            }
        } );
    }

    /**
     * Hide zero-value fields in My Account order/shop summaries.
     * This is intentionally generic: it looks for amount-like elements and
     * hides the parent row/line if the parsed value is zero.
     */
    function juncHideZeroAccountSummaries() {
        if ( ! $( 'body' ).hasClass( 'woocommerce-account' ) ) {
            return;
        }

        // Common WooCommerce account tables (orders, downloads, etc.)
        $( '.woocommerce-MyAccount-content table' ).each( function() {
            var $table = $( this );

            $table.find( 'tbody tr, tr' ).each( function() {
                var $row = $( this );
                var $amountCells = $row.find( 'td, th' );
                var hideRow = false;

                $amountCells.each( function() {
                    var $cell  = $( this );
                    var amount = juncParsePrice( $cell.html() );

                    if ( ! isNaN( amount ) && amount === 0 ) {
                        hideRow = true;
                    }
                } );

                if ( hideRow ) {
                    $row.css( 'display', 'none' );
                }
            } );
        } );
    }

    $( function() {

        // Mini-cart item counter.
        $( document ).on( 'added_to_cart removed_from_cart wooaa_added_to_cart', function( event, fragments ) {
            if ( fragments && fragments['div.widget_shopping_cart_content'] ) {
                // Create a temporary div to parse the HTML
                const tempDiv = document.createElement( 'div' );
                tempDiv.innerHTML = fragments['div.widget_shopping_cart_content'];

                // Find all cart items and sum their quantities
                const cartItems = tempDiv.querySelectorAll( '.woocommerce-mini-cart-item' );
                let totalItems  = 0;

                cartItems.forEach( item => {
                    const quantityText = item.querySelector( '.quantity' ).textContent;
                    const quantity     = parseInt( quantityText, 10 );
                    if ( ! isNaN( quantity ) ) {
                        totalItems += quantity;
                    }
                } );

                // Update cart total (assuming you have an element to display the total)
                $( '.js-cartCount' ).text( totalItems );
            }
        } );

        // Reveal cart update button when quantity changes.
        $( document.body ).on( 'change', '.product-quantity input.qty', function() {
            $( this ).closest( '.product-quantity' ).find( '.js-updateCartItem' ).show();
        } );

        // Initial run on page load.
        juncHideZeroCartTotals();
        juncHideZeroAccountSummaries();

        // Re-run when cart fragments are updated (AJAX updates).
        $( document.body ).on( 'updated_cart_totals updated_wc_div', function() {
            juncHideZeroCartTotals();
        } );

        // Account pages are not usually AJAX-updated, but in case of JS navigation, re-run.
        $( document.body ).on( 'wc_myaccount_content_loaded', function() {
            juncHideZeroAccountSummaries();
        } );

    } );

} )( jQuery );